
import Vue, { PropType } from 'vue'
// import { mapGetters } from 'vuex'
// import toggleArrayItemMixin from '@/mixins/toggleArrayItemMixin'

import wait from '@/helpers/wait'

// import JDateField from '@/../../../generic-components/controls/JDateField.vue'
import JDateField from '@/ui/controls/JDateField.vue'
import JFileInputImage from '@/ui/controls/JFileInputImage.vue'

import { formatDate } from '@/helpers/dateHelpers'
// import { createUUID } from '@/helpers/uuid';

import logCategories, { logCategoryDefaults } from '@/ref/logCategories'
// import logCategories from '@/ref/logCategories';

import { uppercaseFirstLetter } from '@/helpers/strings'

import { id, dateOnly } from '@/types/models'
import Plant from '@/models/Plant'
// import Plant from '@/models/Plant';
// import LogItem from '@/models/LogItem';

import JFileContainer from '@/models/JFileContainer'

type logItemInputAny = string | dateOnly | undefined | null | id[]

interface LogItemInput {
  date: dateOnly
  category?: string
  type?: string
  note: string | null

  refs?: id[]

  [key: string]: logItemInputAny
}

interface CategoryObject {
  id: string
  name: string
}

interface KeyValueInterface<T> {
  [key: string]: T
}

export default Vue.extend({
  components: {
    JDateField,
    JFileInputImage,
  },
  // mixins: [toggleArrayItemMixin],
  props: {
    // value: Array as PropType<id[]>,
    gardenId: String,
    plantIds: Array as PropType<id[]>,
    category: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    input: {
      date: formatDate(new Date()),
      category: undefined,
      type: undefined,
      note: null,
    } as LogItemInput,

    images: [] as Array<JFileContainer>,

    submitting: false,
  }),
  computed: {
    // ...mapGetters({
    //   // plants: 'plants',
    //   // categories: 'log/categories',
    //   types: 'gardens/log/types',
    //   categoryTypes: 'gardens/log/categoryTypes',
    // }),
    plants(): Plant {
      return this.$store.getters['gardens/plants/inGarden'](this.gardenId)
    },
    types(): string[] {
      return this.$store.getters['gardens/log/types'](this.gardenId)
    },
    categoryTypes(): KeyValueInterface<Array<string>> {
      return this.$store.getters['gardens/log/categoryTypes'](this.gardenId)
    },
    filteredTypes(): string[] {
      return this.input.category && this.categoryTypes[this.input.category]
        ? this.categoryTypes[this.input.category]
        : this.types
    },
    categories(): string[] {
      return logCategories
    },
    // categoryObjects(): CategoryObject[] {
    //   return this.categories.map((c: string) => ({
    //     id: c,
    //     name: uppercaseFirstLetter(c),
    //   }))
    // },
    // plantIds(): id[] {
    //   return this.value
    // },
    // categoryPlural() {
    //   return (this.input.category || this.category || this.categories[0].id) + 's'
    // },
    // types() {
    //   return this.plants
    //     .filter((p: Plant) => p.log)
    //     .map((p: Plant) => p.log
    //       .filter((l: LogItem) => l.category === this.category)
    //       .map((l: LogItem) => l.type)
    //     )
    //     .flat(1)
    // },
  },
  created() {
    if (this.category) {
      this.input.category = this.category

      const defaultsObj = logCategoryDefaults as KeyValueInterface<
        KeyValueInterface<logItemInputAny>
      >
      const defaultObj = defaultsObj[
        this.category
      ] as KeyValueInterface<logItemInputAny>

      if (defaultObj) {
        Object.entries(defaultObj).forEach(([key, value]) => {
          // const key = defaults[0] as string
          // const value = defaults[1]
          this.input[key] = value
        })
      }
    }

    // this.categories = logCategories.map((c: string) => ({
    //   id: c,
    //   name: uppercaseFirstLetter(c),
    // }))
  },
  methods: {
    uppercaseFirstLetter: (c: string): string => uppercaseFirstLetter(c),
    onPlantChange(e: id[]): void {
      // this.$emit('input', [e])
      this.$emit('input', e)
    },

    isInvalid(): string | null {
      if (!(this.plantIds && this.plantIds.length > 0)) return 'select plant(s)'
      if (!this.input.date) return 'select a date'
      if (!this.input.category) return 'select a category'
      if (!this.input.type) return 'select a type'
      return null
    },
    async submit(): Promise<void | boolean> {
      await wait(100) // workaround for https://github.com/vuetifyjs/vuetify/issues/10825

      // validate form
      const isInvalid = this.isInvalid()
      if (isInvalid) {
        this.$store.dispatch('snackbars/error', isInvalid)
        return false
      }

      this.submitting = true

      // const batchId = this.value.length > 1 ? createUUID() : null

      const logItem = this.input
      // logItem.batchId = batchId
      // logItem.plantIds = this.plantIds
      logItem.refs = this.plantIds.map(
        (plantId: id) => `gardens/${this.gardenId}/plants/${plantId}`
      )

      // Promise.all(
      //   this.value.map(plantId => this.$store.dispatch('plants/log/add', { plantId, logItem }))
      // )
      this.$store
        .dispatch('gardens/log/add', {
          gardenId: this.gardenId,
          item: logItem,
          images: this.images || [],
        })
        .then(() =>
          this.$store.dispatch(
            'snackbars/add',
            `Added ${logItem.category}: ${logItem.type}`
          )
        )
        .then(() => this.$emit('close'))
        // .catch(err => console.error(err))
        .catch((err) => this.$store.dispatch('snackbars/error', err.message))
        .finally(() => (this.submitting = false))
    },
  },
})
